import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const variants = {
  open:   { opacity: 1, x: 0,      pointerEvents: "auto" as const },
  closed: { opacity: 0, x: "-100%", pointerEvents: "none" as const },
};

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  const location = useLocation();
  const isBookingPage = location.pathname === "/booking";
  const isStatusPage  = location.pathname === "/status";

  const linkClass = (active: boolean) =>
    `relative text-sm font-medium transition-colors pb-1 ${
      active ? "text-[#FF5A22]" : "text-[#a0aec0] hover:text-white"
    }`;

  return (
    <nav
      className="fixed top-0 w-full z-10 px-4 py-2"
      style={{
        background: "rgba(15,20,25,0.85)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderBottom: "1px solid rgba(255,90,34,0.12)",
      }}
    >
      <div className="container mx-auto">
        <div className="flex items-center justify-between">

          {/* Logo — bigger, no text, navigates home */}
          <Link to="/" className="flex items-center">
            <motion.img
              src="/six2o-gold-logo.png"
              alt="Six2O"
              className={`${isBookingPage ? "h-16" : "h-12"} rounded-xl object-contain`}
              whileHover={{ scale: 1.06, filter: "drop-shadow(0 0 8px rgba(255,90,34,0.55))" }}
              transition={{ duration: 0.18 }}
            />
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className={linkClass(!isBookingPage && !isStatusPage)}>
              Home
              {!isBookingPage && !isStatusPage && (
                <motion.div layoutId="activeTab"
                  className="absolute -bottom-0.5 left-0 right-0 rounded-full"
                  style={{ height: 2, background: "linear-gradient(90deg,#FF5A22,#FF8B5E)" }}
                />
              )}
            </Link>
            <Link to="/booking" className={linkClass(isBookingPage)}>
              Create Booking
              {isBookingPage && (
                <motion.div layoutId="activeTab"
                  className="absolute -bottom-0.5 left-0 right-0 rounded-full"
                  style={{ height: 2, background: "linear-gradient(90deg,#FF5A22,#FF8B5E)" }}
                />
              )}
            </Link>
            <Link to="/status" className={linkClass(isStatusPage)}>
              Booking Status
              {isStatusPage && (
                <motion.div layoutId="activeTab"
                  className="absolute -bottom-0.5 left-0 right-0 rounded-full"
                  style={{ height: 2, background: "linear-gradient(90deg,#FF5A22,#FF8B5E)" }}
                />
              )}
            </Link>
          </div>

          {/* Mobile hamburger / close toggle */}
          <button
            onClick={toggleMenu}
            className="md:hidden text-white focus:outline-none p-1"
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isOpen
                ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
              }
            </svg>
          </button>
        </div>

        {/* Mobile menu */}
        <motion.div
          className="md:hidden absolute top-16 left-0 w-full px-5 py-4 space-y-4 z-10"
          style={{
            background: "rgba(15,20,25,0.95)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            borderBottom: "1px solid rgba(255,90,34,0.12)",
          }}
          initial="closed"
          animate={isOpen ? "open" : "closed"}
          variants={variants}
        >
          <Link to="/"
            className={`block py-1 text-sm font-medium ${!isBookingPage && !isStatusPage ? "text-[#FF5A22]" : "text-white"}`}
            onClick={toggleMenu}>
            Home
          </Link>
          <Link to="/booking"
            className={`block py-1 text-sm font-medium ${isBookingPage ? "text-[#FF5A22]" : "text-white"}`}
            onClick={toggleMenu}>
            Create Booking
          </Link>
          <Link to="/status"
            className={`block py-1 text-sm font-medium ${isStatusPage ? "text-[#FF5A22]" : "text-white"}`}
            onClick={toggleMenu}>
            Booking Status
          </Link>
        </motion.div>
      </div>
    </nav>
  );
};

export default Navbar;
